<footer class="footer fixed-top social">

    <div class="row justify-content-between">
        <div class="col-6">
            <div>&nbsp;</div>
        </div>
        <div class="col-6">
            <div class="social-icons">
                <a href="https://www.facebook.com" target="_blank" class="icon fb">
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.twitter.com" target="_blank" class="icon twitter">
                  <i class="fab fa-twitter"></i>
                </a>
                <a href="https://www.youtube.com" target="_blank" class="icon youtube">
                  <i class="fab fa-youtube"></i>
                </a>
              </div>
        </div>
    </div>
    </footer>
<nav class="navbar navbar-expand-sm navbar-dark bg-dark mt-5">
    <div class="container">
        <a id="logo" routerLink="/home" class="navbar-brand">
            <img src="assets/img/base/logo.png" alt="Boundedline Logo">
        </a>
        <div class="collapse navbar-collapse">
            <ul class="navbar-nav ml-auto">
                <li *ngIf="authService.getUser() as user">
                    <a routerLink="/dashboard" class="nav-link">
                        {{user.displayName}}</a>
                </li>
                <li><a routerLink="/home" class="nav-link">Home</a></li>
                <li><a routerLink="/advanced" class="nav-link">Advanced</a></li>
            </ul>
        </div>
    </div>
</nav>